import { Controller } from "@hotwired/stimulus"

// Ask Sibyl drawer (plan RATIFIED 2026-08-13): open/close, example-question
// fill, clear-on-send, keep the transcript scrolled, and "New question"
// (clears the conversation id so the server starts a fresh thread). Answers
// arrive over Turbo Streams; this controller never renders content itself.
export default class extends Controller {
  static targets = ["drawer", "backdrop", "input", "transcript", "form", "empty", "contextChip"]

  connect() {
    this.observer = new MutationObserver(() => this.afterTranscriptChange())
    if (this.hasTranscriptTarget) {
      this.observer.observe(this.transcriptTarget, { childList: true, subtree: true })
    }
    this.boundKey = (e) => { if (e.key === "Escape") this.close() }
  }

  disconnect() {
    this.observer?.disconnect()
    document.removeEventListener("keydown", this.boundKey)
  }

  toggle() {
    if (!this.hasDrawerTarget) return
    this.drawerTarget.hidden ? this.open() : this.close()
  }

  open() {
    if (!this.hasDrawerTarget) return
    this.drawerTarget.hidden = false
    if (this.hasBackdropTarget) this.backdropTarget.hidden = false
    document.addEventListener("keydown", this.boundKey)
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  close() {
    if (this.hasDrawerTarget) this.drawerTarget.hidden = true
    if (this.hasBackdropTarget) this.backdropTarget.hidden = true
    document.removeEventListener("keydown", this.boundKey)
  }

  example(event) {
    this.inputTarget.value = event.currentTarget.dataset.question
    this.inputTarget.focus()
  }

  submitOnEnter(event) {
    if (event.shiftKey) return // shift+enter = newline
    event.preventDefault()
    this.formTarget.requestSubmit()
  }

  sent(event) {
    if (event.detail?.success === false) return
    this.inputTarget.value = ""
    if (this.hasEmptyTarget) this.emptyTarget.hidden = true
  }

  clearContext() {
    const type = document.getElementById("sibyl-context-type")
    const id = document.getElementById("sibyl-context-id")
    if (type) type.value = ""
    if (id) id.value = ""
    if (this.hasContextChipTarget) this.contextChipTarget.remove()
  }

  newConversation() {
    const field = document.getElementById("sibyl-conversation-id")
    if (field) field.value = ""
    this.transcriptTarget.querySelectorAll(".spt-sibyl-pair").forEach(el => el.remove())
    if (this.hasEmptyTarget) this.emptyTarget.hidden = false
    this.inputTarget.focus()
  }

  afterTranscriptChange() {
    if (this.hasEmptyTarget && this.transcriptTarget.querySelector(".spt-sibyl-pair")) {
      this.emptyTarget.hidden = true
    }
    this.transcriptTarget.scrollTop = this.transcriptTarget.scrollHeight
  }
}
